import { mapGetters } from "vuex";
import { productGroupsGetTotalPriceAndDiscount } from "../domains2/productGroups/productGroupsGetTotalPrice";
import { globalSunsetPlusDiscountRule, isPlusDiscountBetterThanProductDiscount } from "../helper/CatalogPricesHelper";

export default {
	computed: {
		...mapGetters(["featureToggles","applicationUserData", "vouchersRedeemed", "isSubscribed", "subscriptionDetails", "orderLines"])
	},
	methods: {
		isDiscountWithVoucher(discount) {
			return discount && Array.isArray(discount.voucherPattern) && discount.voucherPattern.length > 0;
		},
		discountPrice(item) {
			const self = this;
			if(typeof item.productPrice === "object") {
				const product = item.product ? item.product : item;
				const {discount, options} = product;
				if(self.isDiscountWithVoucher(discount) || (options.isPrize && options.isPrize.fromGame)) {
					return item.productPrice.basePrice || item.productPrice.discountPrice;
				} else {
					if (self.featureToggles.enableProductBestPriceInCatalogAndCart && self.isSubscribed && globalSunsetPlusDiscountRule(self.$store)) {
						let {basePrice, discountPrice } = item.productPrice;
						if (product.departmentId === 2) {
							const {price, discountValue} = productGroupsGetTotalPriceAndDiscount(product);
							basePrice = price;
							discountPrice = basePrice - discountValue;
						}
						const isPlusDiscountBetter = isPlusDiscountBetterThanProductDiscount({store: self.$store, basePrice, discountPrice});
						return isPlusDiscountBetter ? basePrice : discountPrice;
					} else {
						if (product.discount && product.discount.options && product.discount.options.qualifyingProductIds) {
							const quantityLimit = product.discount.options.quantityLimit;
							const qualifyingProductsCountInCart = this.orderLines.reduce((acc, curr) => {
								if (product.discount.options.qualifyingProductIds.includes(curr.productId)) {
									return acc + curr.quantity;
								}
								return acc;
							}, 0);
							const allowedQuantityForDiscount = quantityLimit ? Math.min(qualifyingProductsCountInCart, quantityLimit) : qualifyingProductsCountInCart;
							const discountedProductsCountInCart = this.orderLines.reduce((acc, curr) => {
								if (product.discount.productPattern.includes(curr.productId)) {
									return acc + curr.quantity;
								}
								return acc;
							}, 0);
							if (
								!qualifyingProductsCountInCart ||
									(qualifyingProductsCountInCart && discountedProductsCountInCart >= allowedQuantityForDiscount)
							) {
								return item.productPrice.basePrice || item.productPrice.discountPrice;
							}
						}
						return item.productPrice.discountPrice || item.productPrice.basePrice;
					}
				}
			}
			return item.productPrice;
		}
	}
};